<template>
  <div id="app">
    <div class="home-box">
      <top v-if="topshow" class="bg-white"></top>
      <div style="min-width: 1024px">
        <router-view style="min-width: 1024px"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/pc/top";
import pf from "@/publicFn/baseFn";
export default {
  name: "app",
  components: {
    top,
  },
  created() {
    if (this.$store.state.bases.urlArr.length > 0) {
      let arr = this.$store.state.bases.urlArr;
      let item = new Map();
      for (let i = 0; i < arr.length; i++) {
        item.set(arr[i].IAKey, arr[i].IAValue);
      }
      this.$store.commit("bases/UpUrlMap", item);
      pf.getAreaGetListLevel();
    } else {
      pf.GetInterfaceAddress();
    }
  },
  computed: {
    topshow() {
      return this.$store.state.isShow.tops;
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  height: 100vh;
  margin: 0 auto;
  //overflow: auto;
  ::-webkit-scrollbar {
    width: 0;
  }
  font-size: 0.16rem;
}
.top_fixed {
  //position:fixed;
  //top: 0;
  //z-index: 2000;
}
.home_relative {
  //position:relative;
  //top: 0.81rem;
}
.home-top {
  margin: 0 auto;
}
.home-box {
  margin: 0 auto;
  overflow-y: auto;
}
.font_shadow {
  font-weight: bold;
  font-size: 0.22rem;
  text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
}
.flex_row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_row_start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex_row_end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.flex_column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.flex_column_end {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
button {
  transition: all 0.1s;
}
button:active,
.regBtn:active {
  transform: scale(1.05);
}

.page_img {
  width: 100%;
  img {
    width: 100%;
  }
}

.page_system {
  //flex_column
  .sys_title {
    // flex_column
    .line_circle {
      width: 4rem;
      margin-top: 0.25rem;
      display: flex;
      flex-direction: column;
      position: relative;
      .line {
        height: 0.04rem;
        background: #d7d7d7;
      }
      .circle {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);
        width: 0.14rem;
        height: 0.14rem;
        border: 0.04rem solid #d7d7d7;
        background: #fff;
        border-radius: 50%;
      }
    }
  }
  .sys_main {
    // flex_row
    .sys_left {
      flex: 1;
      width: 50%;
      img {
        width: 60%;
      }
    }
    .sys_right {
      // flex_column
      flex: 1;
      width: 50%;
      text-align: left;
      .title {
        font-weight: bold;
      }
      .info {
        margin-top: 0.22rem;
        font-size: 0.15rem;
      }
      .tag {
        span {
          display: inline-block;
          border-radius: 50%;
        }
      }
    }
  }
  .sys_main1 {
    img {
    }
  }
}

.page_decorate {
  // flex_row
  .decorate_item {
    // flex_row
    .decorate_small_item {
      // flex_column
      border: 0.01rem solid #35ace1;
      border-radius: 0.05rem;
      padding: 0.1rem 0.15rem;
      .decorate_title {
      }
      .decorate_info {
      }
    }
    .decorate_line {
      // flex_row
      position: relative;
      span {
        position: absolute;
        display: inline-block;
        border-radius: 50%;
      }
    }
  }
  .decorate_item:last-child .decorate_line {
    display: none;
  }
}

.page_content {
  //flex_row
  .content_title {
    position: relative;
    .back_left {
      position: absolute;
      left: 0%;
      transform: translate(0, 0);
      height: 100%;
    }
    .back_right {
      position: absolute;
      right: 0%;
      transform: translate(0, 0);
      height: 100%;
    }
    .page_summary {
      margin: 0.4rem 0.5rem;
      font-size: 0.3rem;
    }
  }
}

.page_main {
  // flex_column
  width: 100%;
  .main_explain {
    text-align: left;
    text-indent: 2em;
    border: 0.02rem solid #68bdee;
    border-radius: 0.22rem;
  }
}
</style>
